import { FieldTypes } from "../../types/fieldInstance.interface";

export const spanTwoFields: FieldTypes[] = [
  FieldTypes.RelatedList,
  FieldTypes.BranchedMultiSelectasCheckBoxes,
];

export const inlineRLFields: { [x: string]: string } = {
  Care_Provided__c: "careProvided",
};

export const careFields = {
  Care_Provided_Prior_To_Incident__c: "Care_Provided_Prior_to_Incident__c",
  DateTime_repositioned__c: "Date_Time_Repositioned__c",
  Repositioned_by__c: "Re_positioned_By__c",
  DateTime_visually_observed__c: "Date_Time_Visually_observed__c",
  Describe_visual_observation__c: "Visually_Observed_Description__c",
  Visually_observed_by__c: "Visually_Observed_By__c",
  DateTime_transferred__c: "Transferred_Date_Time__c",
  Transfer_type__c: "Transfer_Type__c",
  Transferred_by__c: "Transferred_By__c",
  Describe_transfer_type__c: "Transfer_Type_Other_Describe__c",
  DateTime_received_medication__c: "Date_Time_Received_Medication__c",
  Given_medication_by__c: "Given_Medication_By__c",
  DateTime_given_fluids_foods__c: "Date_Time_Given_fluids_food__c",
  Given_food_fluids_by__c: "Given_Foods_Fluids_By__c",
  DateTime_toileted__c: "Date_Time_Toileted__c",
  Toileted_by__c: "Toileted_By__c",
  Toilet_details__c: "Toileted_Prior_to_Incident_Details__c",
  Describe_toilet_details__c: "Toileted_Prior_to_Incident_Describe__c",
  Describe_care_provided_prior_to_incident__c:
    "Care_Prior_to_Incident_Describe__c",
  DateTime_of_care_provided_prior_to_inci__c:
    "Care_Prior_to_Incident_Date_Time__c",
};
